import Section from "../section/Section"
import WhyItem from "./WhyItem"
import {Localised} from "../../../../common/types";
import React from "react";
import {getCurrentLang} from "../../../../common/utils/lang";

export interface IWhyReason {
    title: string,
    description: string
}
const reasons:Localised<IWhyReason>[] = require("./reasonsToTry.json");

const WhyYouShouldTrySection = () => {
    const activeLang = getCurrentLang();

    return (
        <Section titlePath="home.why-section.title">
            <ul className="grid grid-cols-none md:grid-cols-2 grid-rows-3 gap-[32px]" >
                {reasons.map((reason, i) =>
                    <WhyItem key={`reason-${i}`} reason={reason[activeLang]} />
                )}
            </ul>
        </Section>
    )
};

export default WhyYouShouldTrySection;
